// extracted by mini-css-extract-plugin
export default {"logoContainer":"EditClientModal-module__logoContainer--vtvfQ","logo":"EditClientModal-module__logo--nejuf"};